import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import { Routes } from '../routes';

export default function AdminProtectedRoute({ component: Component, render, ...rest }) {
  const { isAdminAuthenticated } = useAdminAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAdminAuthenticated) {
          return (
            <Redirect
              to={{ pathname: Routes.AdminLogin.path, state: { from: props.location } }}
            />
          );
        }
        if (render) return render(props);
        return <Component {...props} />;
      }}
    />
  );
}
